import React from 'react';
import config from 'config';
import {DocumentList, File} from 'components/documents';

import {statuses} from '../statuses';

export const MainInformation = ({ document }) => (
  <DocumentList>
    <li>Номер документа: <strong>{document.get('number')}</strong></li>
    <li>Дата створення: <strong>{new Date(document.get('date_created')).toLocaleString('uk-UA', config.options)}</strong></li>
    <li>Стан документа: <strong>{statuses[document.get('current_status')]}</strong></li>
    <li>Короткий опис документа: <strong>{document.get('description') ? document.get('description') : "Опис відсутній"}</strong></li>
    <li>Розсилка: <strong>{document.get('is_distribution') ? (
      <i style={{color: "#edbd2f", fontSize: "24px"}} className="fa fa-check-circle" aria-hidden="true"></i>
    ):(
      <i style={{color: "#d73925", fontSize: "24px"}} className="fa fa-times-circle-o" aria-hidden="true"></i>
    )}</strong></li>
    <File>Файл: <a href={document.get('attachment')} target="_blank"><i className="fa fa-file" aria-hidden="true"></i> <span><strong>Завантажити</strong></span></a></File>
  </DocumentList>
);



// WEBPACK FOOTER //
// ./src/admin/documents/detail/main-information.js